export default {
    name: 'codigos',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-codigos',
            component: () => import('@/modules/codigos/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-codigos',
            component: () => import('@/modules/codigos/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-codigos',
            component: () => import('@/modules/codigos/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}